import { render, staticRenderFns } from "./RegisteredLicenses.vue?vue&type=template&id=1f0c7374&"
import script from "./RegisteredLicenses.vue?vue&type=script&lang=js&"
export * from "./RegisteredLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports